import { render, staticRenderFns } from "./pointsChange.vue?vue&type=template&id=48732718&scoped=true&"
import script from "./pointsChange.vue?vue&type=script&lang=js&"
export * from "./pointsChange.vue?vue&type=script&lang=js&"
import style0 from "./pointsChange.vue?vue&type=style&index=0&id=48732718&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48732718",
  null
  
)

export default component.exports